import { API } from 'aws-amplify';

export function getAirports(val) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/airports/${val}`);
}
